import { getIsB2BOrCurrentUserPrivateAdvertiser } from '@app/helpers'
import { useTranslatedSystemMessage } from '@app/hooks'
import { useUser } from '@app/hooks'

import { isB2BView } from '@app/utils'

import { Icon } from '@lib/components'

import styles from './styles.module.scss'
import { SystemMessageItemProps } from './types'

export const SystemMessageItem = ({ message, conversation }: SystemMessageItemProps) => {
  const translatedText = useTranslatedSystemMessage(message, conversation)
  const { currentUser } = useUser()
  const isB2B = Boolean(isB2BView())
  const isB2BOrCurrentUserPrivateAdvertiser =
    getIsB2BOrCurrentUserPrivateAdvertiser(
      conversation.participants,
      currentUser?.id,
      isB2B
    )
  const showSystemIcon =
    isB2BOrCurrentUserPrivateAdvertiser &&
    message.systemNotificationType === 'UnrepliedNotificationSent'

  if (!translatedText) {
    return null
  }
  return (
    <div className={styles.systemMessage}>
      {showSystemIcon && <Icon path="icons/icon-system-message" />}
      {translatedText}
    </div>
  )
}
